import { render, staticRenderFns } from "./table-com.vue?vue&type=template&id=5dc4ff97&scoped=true&"
import script from "./table-com.vue?vue&type=script&lang=js&"
export * from "./table-com.vue?vue&type=script&lang=js&"
import style0 from "./table-com.vue?vue&type=style&index=0&id=5dc4ff97&lang=scss&scoped=true&"
import style1 from "./table-com.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc4ff97",
  null
  
)

export default component.exports